import { KeepAliveService } from '../services/keep-alive.service';
import { KeepAliveModule } from '../keep-alive.module';

export function LogUserInteraction() {
  return function (target: unknown, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: unknown[]): unknown {
      const service = KeepAliveModule.injector.get<KeepAliveService>(KeepAliveService);

      service.logInteraction();

      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
}
